export default {
  slideItem: {
    
  }
};
